module.exports = __webpack_public_path__ + "static/media/file3.d5fa137e.png";